import { useNavigate } from 'react-router-dom';
import styles from './PatCancelModal.module.scss';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';
interface IPropsType {
  closer: React.Dispatch<React.SetStateAction<boolean>>;
}

function PayCancelModal(props: IPropsType) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className={`${styles.container} ${isMobile ? styles.isMobile : ''}`}>
      <div className={styles.contentWrap}>
        <div className={styles.textWrap}>
          <span>Your payment has failed. </span>
          <br />
          <span>Please try again.</span>
        </div>
        <div
          className={styles.btnWrap}
          onClick={() => {
            props.closer(false);
            navigate('/');
          }}
        >
          <div className={styles.homeBtn}>Home</div>
        </div>
      </div>
    </div>
  );
}

export default PayCancelModal;
